import { render } from "./step_templete.vue?vue&type=template&id=56b62e19&scoped=true"
import script from "./step_templete.vue?vue&type=script&lang=js"
export * from "./step_templete.vue?vue&type=script&lang=js"

import "./step_templete.vue?vue&type=style&index=0&id=56b62e19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b62e19"]])

export default __exports__